/** @jsxImportSource @emotion/react */
import { TableContainer } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import ComplainHeader from "./component/complain-header";
import ComplainRow from "./component/complain-row";
import { TComplain } from "apis/meeting-room-complain";
import ComplainEmptyRow from "./component/complain-empty-row";

type ResolveComplainListProps = {
  open?: boolean;
  totalPage: number;
  nowPage: number;
  onChangePage?: (page: number) => void;
  complainList: TComplain[];
  checkedComplainList?: TComplain[];
  onHandleCheck?: (selectedComplain: TComplain) => void;
  onHandleAllCheck?: (isChecked: boolean, complainList: TComplain[]) => void;
};

const ResolveComplainList = ({
  open,
  totalPage,
  nowPage,
  onChangePage,
  complainList,
  checkedComplainList,
  onHandleCheck,
  onHandleAllCheck,
}: ResolveComplainListProps) => {
  return (
    <TableContainer style={{ display: open ? "flex" : "none" }}>
      <ComplainHeader
        section="처리 완료 민원"
        totalCount={complainList.length}
        checkedComplainList={checkedComplainList}
        onHandleAllCheck={(isChecked) => onHandleAllCheck?.(isChecked, complainList)}
      />
      {complainList.map((complain, idx) => (
        <ComplainRow
          complain={complain}
          checkedComplainList={checkedComplainList}
          onHandleCheck={() => onHandleCheck?.(complain)}
        />
      ))}
      {complainList.length === 0 ? <ComplainEmptyRow /> : null}
      {totalPage && nowPage ? (
        <div style={{ marginTop: 48 }}>
          <UI.Pagination
            pageCount={totalPage}
            currentPage={nowPage}
            onChange={(page) => {
              onChangePage?.(page);
            }}
          />
        </div>
      ) : null}
    </TableContainer>
  );
};
export default ResolveComplainList;
